import { createAction } from '@reduxjs/toolkit';

export const addImageIdAction = createAction<{ id: string; src: string }>('images/addImageId');
